import React, { useEffect, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import DashboardWidget from "../components/DashboardWidget";
import { get } from "../helpers/Dashboard";
import dayjs from "dayjs";
import { getInvoices } from "../helpers/Invoices";
import { Link } from "react-router-dom";
import { format } from "../helpers/Currency";
import Pagination from "../components/Pagination";


export default function Invoices() {
    const { appState } = useAppState();
    const [invoices, setInvoices] = useState<Array<any>>([])
    const [page, setPage] = useState<number>(1)
    const [meta, setMeta] = useState<any>({
        page: 1,
        totalPages: 1,
    });

    useEffect(() => {
        getInvoices(10, page).then((result) => {
            setInvoices(result.data)
            setMeta({
                page: result.current_page,
                totalPages: result.last_page,
            })
        })
    }, [page])

    return (
        <>
            <div className="flex justify-between items-center">
                <h1 className="text-xl">Invoices</h1>
                <Link to="/invoices/create" className="px-4 py-2 bg-blue-500 text-white rounded">Create invoice</Link>
            </div>
            <div className="mt-3 p-3 rounded bg-white">
                <table className="w-full">
                    <thead className="text-left">
                        <tr className="border-b-1">
                            <th className="p-2">Id</th>
                            <th className="p-2">Client</th>
                            <th className="p-2">Total</th>
                            <th className="p-2">Status</th>
                            <th className="p-2 text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoices.map((invoice: any) => {
                            return (
                                <tr className="border-b-1 border-gray-300">
                                    <td className="p-2">
                                        <Link to={`/invoices/${invoice.id}`}>{invoice.id}</Link>
                                    </td>
                                    <td className="p-2">{invoice.client.name}</td>
                                    <td className="p-2">{format(invoice.total / 100, invoice.currency)}</td>
                                    <td className="p-2">{invoice.status}</td>
                                    <td className="p-2 ">
                                        <ul className="flex justify-end gap-x-2">
                                            <li>
                                                <Link to={`/invoices/${invoice.id}`}>View</Link>
                                            </li>
                                            <li>
                                                <a target="_blank" href={invoice.payment_link}>Link</a>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            {invoices && invoices.length > 0 ? (
                <div className="w-full mt-5">
                    <Pagination page={meta.page} totalPages={meta.totalPages} onCallback={setPage} />
                </div>
            ) : null}

        </>
    );
}
